import { render, staticRenderFns } from "./CategoriasCriar.vue?vue&type=template&id=179eda5e"
import script from "./CategoriasCriar.vue?vue&type=script&lang=js"
export * from "./CategoriasCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports